import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import { PreviewButtons } from "./Buttons/index.js";
import { useStyles } from "./Preview.styles.js";
const DownloadableFileIcon = (t0)=>{
    const $ = c(19);
    const { shape, children, onClickDownload, withCollapsableFooter } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const { classes } = useStyles(t1);
    let t2;
    if ($[1] !== classes.collapseWrapper || $[2] !== classes.previewDocx || $[3] !== classes.root) {
        t2 = classnames(classes.root, classes.collapseWrapper, classes.previewDocx);
        $[1] = classes.collapseWrapper;
        $[2] = classes.previewDocx;
        $[3] = classes.root;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== classes.square || $[6] !== shape) {
        t3 = "square" === shape && /*#__PURE__*/ jsx("div", {
            className: classes.square
        });
        $[5] = classes.square;
        $[6] = shape;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== children || $[9] !== classes.docImage) {
        t4 = /*#__PURE__*/ jsx("div", {
            className: classes.docImage,
            children: children
        });
        $[8] = children;
        $[9] = classes.docImage;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== onClickDownload || $[12] !== withCollapsableFooter) {
        t5 = onClickDownload && /*#__PURE__*/ jsx(PreviewButtons, {
            onClickDownload: onClickDownload,
            withCollapsableFooter: withCollapsableFooter,
            clickable: true
        });
        $[11] = onClickDownload;
        $[12] = withCollapsableFooter;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
        t6 = /*#__PURE__*/ jsxs("div", {
            className: t2,
            children: [
                t3,
                t4,
                t5
            ]
        });
        $[14] = t2;
        $[15] = t3;
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
};
export { DownloadableFileIcon };
